import { Yard } from "@mui/icons-material";
import { dueToCustomRange } from "../assets/commonFunction";

export const getChatGroupMenu = (appConstant) => [
  {
    name: appConstant?.chatGroupMenu?.groupMembers,
    value: "members",
  },
  {
    name: appConstant?.chatGroupMenu?.mediaFiles,
    value: "media",
  },
  {
    name: appConstant?.chatGroupMenu?.deactivatePrivateChats,
    value: "privatechat",
  },
  {
    name: appConstant?.chatGroupMenu?.editGroup,
    value: "edit",
  },
  {
    name: appConstant?.chatGroupMenu?.delete,
    value: "delete",
  },
  {
    name: appConstant?.chatGroupMenu?.exit,
    value: "exit",
  },
  {
    name: appConstant?.chatGroupMenu?.chatLanguage,
    value: "language",
  },
  {
    name: appConstant?.chatGroupMenu?.dateTimeFormat,
    value: "dateformat",
  },
];

export const GroupLevelArkchatPermission = {
  USER: 1,
  MANAGER: 2,
  OWNER: 3,
  REMOVE: 4,
};

export const AccountLevelArkchatPermission = {
  USER: 1,
  ADMIN: 2,
  MANAGER: 3,
};

//group level
// user(1),
// manager(2),
// owner(3),
// removed(4);

// account level
// user(1),
// admin(2),
// manager(3);
export const InviteType = {
  internal: 1,
  external: 2,
  ownerInviteType: 0,
};

export const MessageType = {
  Message: 0,
  Task: 1,
  Approval: 2,
  Direct_Mesage: 3,
  Post: 4,
  //for internal use
  ApproveAndAskApproval: 5,
  AssignSubTask: 6, // this is for subtask
  RejectAndAskApproval: 7,
  RequestApprovalOnTask:8
};

// Pending: 1,
// Cancelled: 2,
// Done: 3,
// Delayed: 4,
// Started: 6,

// estimated_time = {}, start_time = 0, actual_time = {}, end_time = 0 linux time stamp
// https://apptest.arkchat.com/v2/chats/task/4 patch
export const TaskStatus = {
  Pending: 1,
  Cancelled: 2,
  Done: 3,
  Delayed: 4,
  Started: 6,
};

export const TaskStatusLabels = {
  [TaskStatus.Pending]: "Pending",
  [TaskStatus.Cancelled]: "Cancelled",
  [TaskStatus.Done]: "Done",
  [TaskStatus.Delayed]: "Delayed",
  [TaskStatus.Started]: "Started",
};

export const subscriptionType = {
  0: "Free Trail",
  1: "Monthly Subscription",
  2: "Yearly Subscription",
};

export const subscriptionPlanType = {
  Monthly: 1,
  Yearly: 2,
};

//   1: "Pending",
//   2: "Cancelled",
//   3: "Completed", // Done
//   4: "Delayed",
//   6: "Started",
export const getTaskStatusLabels = (appConstant) => ({
  1: appConstant?.statusLabels.pending,
  2: appConstant?.statusLabels.cancelled,
  3: appConstant?.statusLabels.completed,
  4: appConstant?.statusLabels.delayed,
  6: appConstant?.statusLabels.started,
});

export const getApprovalStatusLabels = (appConstant) => ({
  1: appConstant?.statusLabels.pending,
  2: appConstant?.statusLabels.cancelled,
  3: appConstant?.statusLabels.approved,
  4: appConstant?.statusLabels.delayed,
  5: appConstant?.statusLabels.rejected,
});

export const taskStatusColor = {
  1: "#F8EBA7",
  2: "#DBDADD",
  3: "#B6EADA",
  4: "#F8C1BA",
  6: "#BBD5F0",
};

export const ApprovalStatus = {
  Pending: 1,
  Cancelled: 2,
  Approved: 3,
  Delayed: 4,
  Rejected: 5,
};

export const approvalStatusColor = {
  1: "#F8EBA7",
  2: "#DBDADD",
  3: "#B6EADA",
  4: "#F8C1BA",
  5: "#D2C9F4",
};

export const priorityValueColor = {
  1: "rgba(147, 184, 248, 1)",
  2: "rgba(227, 72, 231, 1)",
  3: "rgba(219, 0, 17, 1)",
};

export const priorityValueLable = {
  1: "Low",
  2: "Medium",
  3: "High",
};

export const priorityValue = {
  Low: 1,
  Medium: 2,
  High: 3,
};
// export const tasksidebarmenu = [
//   {
//     label: "Done Tasks",
//     value: "3",
//     type: "Status",
//   },
//   {
//     label: "Pending Tasks",
//     value: "1",
//     type: "Status",
//   },
//   {
//     label: "Delayed Tasks",
//     value: "4",
//     type: "Status",
//   },
//   {
//     label: "Priority - High",
//     value: "3",
//     type: "Priority",
//   },
//   {
//     label: "Priority - Medium",
//     value: "2",
//     type: "Priority",
//   },
//   {
//     label: "Priority - Low",
//     value: "1",
//     type: "Priority",
//   },
//   {
//     label: "Repeat Tasks",
//     value: true,
//     type: "Repeat",
//   },
// ];

//due_today:true
//due_next_two_days:true
//due_custom_from:05-01-2026
//due_custom_to:08-01-2026
//started_not_delayed:true
//started_and_delayed:true
//delayed_not_started:true
//delayed:true
//completed_in_time:true
//delayed_completions:true
//completed_but_reopened:true
//high_priority_completed:true
//high_priority_pending:true

export const tasksidebarmenu = [
  {
    label: "Due today",
    key: "due_today",
  },
  {
    label: "High priority",
    key: "high_priority",
  },
  {
    label: "High priority completed",
    key: "high_priority_completed",
  },
  {
    label: "High priority pending",
    key: "high_priority_pending",
  },
  {
    label: "Due in next two days",
    key: "due_next_two_days",
  },
  {
    label: "Due in custom range",
    key: dueToCustomRange,
  },
  {
    label: "Started not delayed",
    key: "started_not_delayed",
  },
  {
    label: "Started and delayed",
    key: "started_and_delayed",
  },
  {
    label: "Delayed and not started",
    key: "delayed_not_started",
  },
  {
    label: "Delayed",
    key: "delayed",
  },
  {
    label: "Completed in time",
    key: "completed_in_time",
  },
  {
    label: "Delayed completions",
    key: "delayed_completions",
  },
  {
    label: "Completed but reopened",
    key: "completed_but_reopened",
  },
  // {
  //   label: "Recurring",
  //   value: true,
  //   type: "Repeat",
  //   key: "recurring",
  // },
];

export const TASK_FILTER_QUERY_CONFIG = {
  due_today: { type: "boolean" },
  due_next_two_days: { type: "boolean" },
  high_priority: { type: "customValue", value: "3", customKey: "priority" },
  high_priority_completed: { type: "boolean" },
  high_priority_pending: { type: "boolean" },

  started_and_delayed: { type: "boolean" },
  started_not_delayed: { type: "boolean" },
  delayed: { type: "boolean" },
  delayed_not_started: { type: "boolean" },
  delayed_rejections: { type: "boolean" },

  completed_in_time: { type: "boolean" },
  delayed_completions: { type: "boolean" },

  completed_but_reopened: { type: "boolean" },

  due_in_custom_range: {
    type: "date_range",
    fromKey: "due_custom_from",
    toKey: "due_custom_to",
  },
};

export const filtersidebarmenu = [
  {
    label: "Due today",
    value: "due_today",
    type: "Date",
    key: "due_today",
  },
  {
    label: "High priority",
    value: "3",
    type: "Priority",
    key: "high_priority",
  },
  {
    label: "Due in next two days",
    value: "due_next_two_days",
    type: "Date",
    key: "due_next_two_days",
  },
  {
    label: "Due in custom range",
    value: dueToCustomRange,
    type: "Date",
    key: dueToCustomRange,
  },
  {
    label: "Delayed",
    value: "4",
    type: "Status",
    key: "delayed",
  },
  {
    label: "Approved in time",
    value: "3",
    type: "Status",
    key: "approved_in_time",
  },
  {
    label: "Delayed Approvals",
    value: "delayed_approvals",
    type: "Status",
    key: "delayed_approvals",
  },
  {
    label: "Rejected in time",
    value: "rejected_in_time",
    type: "Status",
    key: "rejected_in_time",
  },
  {
    label: "Delayed Rejections",
    value: "delayed_rejections",
    type: "Status",
    key: "delayed_rejections",
  },
  {
    label: "Recurring",
    value: true,
    type: "Repeat",
    key: "recurring",
  },
];

export const approvalsidebarmenu = [
  {
    label: "Due today",
    key: "due_today",
  },
  {
    label: "High Priority approved/rejected",
    key: "high_priority_approved_rejected",
  },
  {
    label: "High Priority pending",
    key: "high_priority_pending",
  },
  {
    label: "Due in next two days",
    key: "due_next_two_days",
  },
  {
    label: "Due in custom range",
    key: dueToCustomRange,
  },
  {
    label: "Delayed",
    key: "delayed",
  },
  {
    label: "Approved in time",
    key: "approved_in_time",
  },
  {
    label: "Delayed Approvals",
    key: "delayed_approvals",
  },
  {
    label: "Rejected in time",
    key: "rejected_in_time",
  },

  {
    label: "Delayed rejections",
    key: "delayed_rejections",
  },
];

export const APPROVAL_FILTER_QUERY_CONFIG = {
  due_today: { type: "boolean" },
  due_next_two_days: { type: "boolean" },
  high_priority: { type: "customValue", value: "3", customKey: "priority" },
  high_priority_pending: { type: "boolean" },
  high_priority_approved_rejected: { type: "boolean" },

  delayed: { type: "boolean" },
  approved_in_time: { type: "boolean" },
  delayed_approvals: { type: "boolean" },
  rejected_in_time: { type: "boolean" },

  delayed_rejections: { type: "boolean" },
  
  due_in_custom_range: {
    type: "date_range",
    fromKey: "due_custom_from",
    toKey: "due_custom_to",
  },
};

export const taskAnalyticsContentEnum = {
  pending: {
    title: "Total Pending Tasks",
    countTitle: "Total Pending Tasks",
    color: "rgba(245, 225, 32, 1)",
    backgroundColor: "rgba(118, 118, 118, 0.12)",
  },
  delayed_pending: {
    title: "Delayed Pending Tasks",
    countTitle: "Total Delayed Tasks",
    color: "rgba(255, 68, 80, 1)",
    backgroundColor: "rgba(250, 240, 143, 1)",
  },
  not_delayed_pending: {
    title: "Not Delayed Pending Tasks",
    countTitle: "Total Pending tasks not delayed",
    color: "rgba(245, 225, 32, 1)",
    backgroundColor: "rgba(250, 240, 143, 1)",
  },
  done: {
    title: "Completed Tasks",
    countTitle: "Total Completed Tasks",
    color: "rgba(0, 127, 143, 1)",
    backgroundColor: "rgba(118, 118, 118, 0.12)",
  },
  total: {
    title: "Total Task",
    countTitle: "Total Task",
    color: "rgba(169, 168, 160, 1)",
    backgroundColor: "rgba(118, 118, 118, 0.12)",
  },
  not_started_pending: {
    title: "Pending Tasks Not Started",
    countTitle: "Pending Tasks Not Started",
    color: "rgba(0, 127, 143, 1)",
    backgroundColor: "rgba(118, 118, 118, 0.12)",
  },
  started_pending: {
    title: "Pending tasks started",
    countTitle: "Pending tasks started",
    color: "rgba(0, 127, 143, 1)",
    backgroundColor: "rgba(118, 118, 118, 0.12)",
  },
};

export const approvalAnalyticsContentEnum = {
  pending: {
    title: "Total Pending Approvals",
    totalTitle: "Total Approvals",
    countTitle: "Total Pending Approvals",
    color: "rgba(245, 225, 32, 1)",
    backgroundColor: "rgba(118, 118, 118, 0.12)",
  },
  delayed_pending: {
    title: "Delayed Pending Approvals",
    totalTitle: "Total Approvals",
    countTitle: "Total Delayed Approvals",
    color: "rgba(255, 68, 80, 1)",
    backgroundColor: "rgba(250, 240, 143, 1)",
  },
  not_delayed_pending: {
    title: "Rejected",
    totalTitle: "Total Approvals",
    countTitle: "Rejected",
    color: "rgba(245, 225, 32, 1)",
    backgroundColor: "rgba(250, 240, 143, 1)",
  },
  done: {
    title: "Approved",
    totalTitle: "Total Approvals",
    countTitle: "Approved",
    color: "rgba(0, 127, 143, 1)",
    backgroundColor: "rgba(118, 118, 118, 0.12)",
  },
};

export const daysOfWeek = {
  sunday: 0,
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thrusday: 4,
  friday: 5,
  saturday: 6,
};

export const months = [
  { value: 1, label: "January" },
  { value: 2, label: "February" },
  { value: 3, label: "March" },
  { value: 4, label: "April" },
  { value: 5, label: "May" },
  { value: 6, label: "June" },
  { value: 7, label: "July" },
  { value: 8, label: "August" },
  { value: 9, label: "September" },
  { value: 10, label: "October" },
  { value: 11, label: "November" },
  { value: 12, label: "December" },
];

export const monthMapping = {
  1: "January",
  2: "February",
  3: "March",
  4: "April",
  5: "May",
  6: "June",
  7: "July",
  8: "August",
  9: "September",
  10: "October",
  11: "November",
  12: "December",
};

export const groupMsgDeleteType = {
  me: "deleteGrpMsgForMe",
  all: "deleteGrpMsgForAll",
};

export const serviceTypeValue = {
  1: "Service",
  2: "Product",
  3: "Art",
  4: "Photo",
  5: "Videos",
};

export const serviceTypeName = {
  Service: 1,
  Product: 2,
  Art: 3,
  Photo: 4,
  Videos: 5,
};

export const accountType = {
  Individual: 1,
  Organisation: 2,
};

export const sellerTypeEnum = {
  Empty: 0,
  Agent: 1,
  Distributor: 2,
  Dealer: 3,
};
export const sellerTypeValue = {
  0: "Empty",
  1: "Agent",
  2: "Distributor",
  3: "Dealer",
};
//p=oriority,s=status

export const exploreServiceTypeNameRelation = {
  5: 1,
  4: 2,
  1: 3,
  2: 4,
  3: 5,
};

export const PubnubEventType = {
  PROFILE_UPDATE: "profile-updated",
  GROUP_CREATED: "new-group-created",
  GROUP_DELETED: "group-deleted",
  GROUP_EDITED: "group-setting-updated",
  USER_ADDED_TO_GROUP: "user-added-to-group",
  USER_GROUP_LIST_UPDATED: "user-group-list-updated",
  USER_REMOVED_FROM_GROUP: "user-removed-from-group",
  USER_EXITED_THE_GROUP: "user-exited-the-group",
  TOPIC_CREATED: "topic-created",
  TOPIC_DELETED: "topic-deleted",
  TOPIC_UPDATED: "topic-updated",
  CONTACT_PERMISSION_UPDATED: "contact-updated",
  CONTACT_ADDED: "contact-added-to-account",
  CONTACT_REMOVED: "contact-removed",
  ACCOUNT_SWITCHED: "account-switched",
  CHAT_LANGUAGE_UPDATED: "chat-language-updated",
  MARK_AS_READ: "mark-as-read",
  ACCOUNT_INVITATION: "account-invitation",
  CHAT_MOVED_TO_ANOTHER_TOPIC: "moved-to-topic",
  CHAT_STARRED: "message-starred",
  CHAT_MSG_DELETE: "message-deleted",
  PUBNUB_TOKEN_UPDATE: "token-updated",
  GROUP_ARCHIVED: "group-archived",
  GROUP_UNARCHIVED: "group-unarchived",
  DM_ARCHIVED:"dm-archived",
  DM_UNARCHIVED: "dm-unarchived",
};

export const characterLimit = {
  firstName: 25,
  lastName: 25,
  city: 15,
  organisationName: 50,
};

export const cancelReason = {
  low_quality: "Didn’t find Arkchat’s value proposition useful.",
  too_expensive: "Too expensive.",
  too_complex: "Too difficult to use.",
  missing_features: "Technical glitches.",
  switched_service: "I have decided to use another platform.",
};
